﻿$.fn.dxCtrlIaBc = function custom_dxCtrlIaBc(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrliabc dx-ctrl");
        this.createInstance(new cdxCtrlIaBc(this, option));
    }
    return this;
}

window.cdxCtrlIaBc = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var idIaConversation = null

    var $DivJauge = null
    var $DivEspace = null
    var reqAjaxIa = null
    var dxScroll = null
    var dxQuestion = null
    this.dxBtGo = null
    this.mGetDxQuestion = function () { return dxQuestion }
    var $DivIntro = null
    function mConstruit() {
        container.empty();

        container.css({
            "background-color": theme.backgroundcolorTooltip
        })

        container.css({
            "width": "100%",
            "height": "100%"
        })

        dxScroll = $("<div/>").appendTo(container).dxCtrlScrollView({
            showScrollbar: "always",
            onScroll: function (e) {
                if (dxScroll.disableOnScroll) {
                    dxScroll.disableOnScroll = false
                    return
                }
                dxScroll.hasNewScroll = !e.reachedBottom
            }
        }).dxCtrlScrollView("instance")
        dxScroll.disableOnScroll = false

        var $Table = $("<table style='width:100%'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)


        var $Td = $("<td style='width:1px;vertical-align:bottom;'/>").appendTo($Tr)
        var dxBtHisto = $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-clock-rotate-left",
            hint: "historique de vos conversations",
            onClick: function (e) {
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    showCloseButton: false,
                    target: e.component.element(),
                    position: "left",
                    maxHeight: "95%",
                    width: 300,
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding", "20px")
                        contentElement.css("text-align", "left")
                        option.bddCtrl.mAjaxCall({
                            command: "gethistoallconversationia"
                        }, function (data) {
                            if (typeof data.lst_conversation == 'undefined') data.lst_conversation = []
                            if (data.lst_conversation.length == 0) {
                                $("<div>Aucune conversation avec MIA</div>").appendTo(contentElement)
                            } else {
                                $("<div style='opacity:0.2;'>Historique de vos conversation avec MIA</div>").appendTo(contentElement)
                                var $Table = $("<table style='width:calc(100% - 0px);table-layout:fixed;'/>").appendTo(contentElement)

                                data.lst_conversation.forEach(function (conversation) {
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    var $Td = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;padding:8px 3px;border-radius:5px;' class='state-hover'/>").appendTo($Tr)
                                    $Td.text(conversation.titre)
                                    $Td.attr("title", conversation.titre)
                                    $Td.on("click", function (e) {
                                        tt.hide()
                                        idIaConversation = conversation.id_ia_conversation
                                        dxScroll.content().empty()
                                        option.bddCtrl.mAjaxCall({
                                            command: "gethisto1conversationia",
                                            id_ia_conversation: idIaConversation
                                        }, function (data) {
                                            if (typeof data.lst_question_reponse == 'undefined') data.lst_question_reponse = []
                                            if (data.lst_question_reponse.length == 0) {
                                            } else {
                                                data.lst_question_reponse.forEach(function (questionReponse) {
                                                    mAddQuestion(questionReponse.question)
                                                    mAddReponse(questionReponse.reponse, false)
                                                })
                                            }
                                        })
                                    })

                                    var $Td = $("<td style='width:60px;padding:8px 0;text-align:right;opacity:0.5;'/>").appendTo($Tr)
                                    $Td.text(conversation.dcr.toDateIlya(true))
                                    $Td.attr("title", conversation.dcr.toFrenchDateTime())
                                    var $Td = $("<td style='width:24px;padding:8px 0;text-align:center;border-radius:5px;' class='state-hover'/>").appendTo($Tr)
                                    $Td.attr("title", 'Supprimer définitivement la conversation')
                                    var $Bt = $("<i class='fas fa-eraser' style='font-size:140%;'></i>").appendTo($Td)
                                    $Td.on("click", function (e) {
                                        e.stopPropagation()
                                        option.bddCtrl.mAjaxCall({
                                            command: "supprimerconversationia",
                                            id_ia_conversation: conversation.id_ia_conversation
                                        }, function () {
                                            if (idIaConversation == conversation.id_ia_conversation) {
                                                dxScroll.content().empty()
                                                idIaConversation = null
                                            }
                                            mNotify("La conversation a été supprimée", "success", 6000)
                                        })
                                        tt.hide()
                                    })
                                })

                                var $Tr = $("<tr/>").appendTo($Table)
                                var $Td = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;padding:8px 3px;border-radius:5px;' class='state-hover' colspan='3'><i class='fas fa-certificate'></i> Nouvelle conversation</td>").appendTo($Tr)
                                $Td.on("click", function (e) {
                                    dxScroll.content().empty()
                                    idIaConversation = null
                                    tt.hide()
                                });
                            }
                        })
                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            }
        }).dxCtrlButton("instance")


        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        dxQuestion = $("<div style='margin:10px 5px;'/>").appendTo($Td).dxTextArea({
            label: "Posez votre question à MIA",
            labelMode: 'floating',
            value: "",
            maxHeight: 200,
            minHeight: 50,
            autoResizeEnabled: true,
            onEnterKey: function (e) {
                if (e.event.shiftKey) return
                console.log("onEnterKey " + e.component.option("text"))
                if (e.component.option("text") != null && e.component.option("text").length > 0) Me.dxBtGo.performClick()
            },
            onContentReady: function (e) {
                window.setTimeout(function () { e.component.focus() }, 1000)
            }
        }).dxTextArea("instance")
        var $Td = $("<td style='width:1px;vertical-align:bottom;'/>").appendTo($Tr)
        Me.dxBtGo = $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-check",
            onClick: function (e) {
                if (dxQuestion.option("text") != null && dxQuestion.option("text").length > 0) {
                    dxQuestion.option("disabled", true)
                    if (dxBtHisto) dxBtHisto.option("disabled", true)
                    Me.dxBtGo.element().hide()
                    dxBtStop.element().show()
                    mAddQuestion(dxQuestion.option("text"))
                    $DivJauge = $("<div style='margin:20px;text-align:center;'/>").appendTo(dxScroll.content())
                    $("<div style='display:inline-block;'/>").appendTo($DivJauge).dxCtrlJaugeIa({}).dxCtrlJaugeIa("instance")
                    dxScroll.smoothScrollTo(dxScroll.scrollHeight() + 400, 500)
                    dxScroll.hasNewScroll = false

                    reqAjaxIa = option.bddCtrl.mAjaxCall({
                        command: "questioniadocumentation",
                        question: question,
                        id_ia_conversation: idIaConversation
                    }, function (data) {
                        if (data.pas_de_question == "1") {
                            try {
                                throw new Error("Erreur ia sans question");
                            } catch (e) {
                                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange", function () { })
                            }
                        }
                        reqAjaxIa = null
                        if (typeof data.date_mois != 'undefined' || typeof data.date_jour != 'undefined') {
                            if (typeof data.date_mois != 'undefined') {
                                data.date_mois = data.date_mois.addMonths(1)
                                mNotify("Vous avez dépassé votre quota mensuel de requètes pou MIA. Vous pourrez à nouveau faire des requètes à partir du " + data.date_mois.toFrenchDateTime(), "warning", 6000)
                            } else {
                                data.date_jour = data.date_jour.addDays(1)
                                mNotify("Vous avez dépassé votre quota journalier de requètes pou MIA. Vous pourrez à nouveau faire des requètes à partir du " + data.date_jour.toFrenchDateTime(), "warning", 6000)
                            }
                            dxBtStop.option("disabled", true)
                            $DivJauge.remove()
                            dxBtStop.element().hide()
                            dxBtStop.option("disabled", false)
                            Me.dxBtGo.element().show()
                            if (dxBtHisto) dxBtHisto.option("disabled", false)
                            dxQuestion.option("disabled", false)
                            dxQuestion.option("value", "")
                            dxQuestion.focus()
                        } else {
                            if (idIaConversation == null && typeof data.id_ia_conversation != 'undefined') idIaConversation = data.id_ia_conversation
                            dxBtStop.option("disabled", true)
                            $DivJauge.remove()

                            mAddReponse(data.reponse, true, function () {
                                dxBtStop.element().hide()
                                dxBtStop.option("disabled", false)
                                Me.dxBtGo.element().show()
                                if (dxBtHisto) dxBtHisto.option("disabled", false)
                                dxQuestion.option("disabled", false)
                                dxQuestion.option("value", "")
                                dxQuestion.focus()
                            })
                        }
                    })
                }
            }
        }).dxCtrlButton("instance")
        var dxBtStop = $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-stop",
            onClick: function (e) {
                if (reqAjaxIa) {
                    reqAjaxIa.abort()
                    dxBtStop.element().hide()
                    Me.dxBtGo.element().show()
                    if (dxBtHisto) dxBtHisto.option("disabled", false)
                    $DivJauge.remove()
                    dxQuestion.option("disabled", false)
                }
            }
        }).dxCtrlButton("instance")
        dxBtStop.element().hide()

        $DivIntro = $(option.htmlIntro).appendTo(dxScroll.content())

        resizeObserver.mAdd($Table, function () { dxScroll.element().css("height", "calc(100% - " + $Table.innerHeight() + "px)") })()
    }

    function mAddQuestion(question) {
        $DivIntro.remove()
        var $DivContainer = $("<div style='margin:30px 10px 10px 10px;padding:10px;border-radius:10px;text-align:right;background-color:" + theme.backgroundcolorBase + ";' class='state-hover'/>").appendTo(dxScroll.content()).text(question)
        $DivContainer.on("click", function (e) {
            dxQuestion.option("value", question)
        })
    }
    function mAddReponse(reponse, anime, funcFin) {
        dxScroll.smoothScrollTo(dxScroll.scrollHeight() + 400, 500)
        var html = JSON.parse(reponse).html
        var $CreateSupport = $("<div/>")
        var $DivContainer = $("<div style='margin:10px 10%;font-family:barlow condensed;font-size:110%;'/>").appendTo(dxScroll.content())
        if (anime) {
            var $Div = $("<div/>").html(html)
            var lstEle = $Div.children()
            function mDisplay(idx) {
                if (typeof lstEle[idx] != 'undefined') {
                    var $ele = $(lstEle[idx])
                    mAdd($ele)
                    animateCSS($ele, "lightSpeedInLeft").then((message) => {
                        mDisplay(idx + 1)
                    });
                } else {
                    //fin
                    var lstLink = JSON.parse(reponse).liens
                    if (typeof lstLink != 'undefined') lstLink.forEach(function (link) {
                        var $ele = $("<div>🔗 </div>")
                        var $A = $("<a target='_blank'></a>").appendTo($ele)
                        $A.attr("title", link.description)
                        $A.attr("href", link.url)
                        $A.text(link.description)
                        mAdd($ele)
                    })
                    if (typeof funcFin != 'undefined') funcFin()
                }

                function mAdd($ele) {
                    $ele.css("--animate-duration", "0.6s") //0.4s
                    $ele.css("animation-delay", ((idx == 0) ? "0" : "0.4s"))
                    dxScroll.disableOnScroll = true
                    $ele.appendTo($DivContainer)
                    if (!dxScroll.hasNewScroll) {
                        dxScroll.disableOnScroll = true
                        dxScroll.smoothScrollTo($ele.position().top, 2000)
                        dxScroll.hasNewScroll = false
                    } else {
                        dxScroll.update()
                    }
                }
            }
            mDisplay(0)
        } else {
            $DivContainer.html(html)
            dxScroll.smoothScrollTo(dxScroll.scrollHeight() + 400, 500)
        }
    }

    this.element = function () { return container }

    mConstruit();
}


